/**
 * 일반 캔버스 도구와 다른, 교실 전용 기능. 본문은 지금 배포된 동작만 말한다
 * (근거: docs/superpowers/specs/2026-09-29-landing-feature-showcase-design.md).
 */
export const FEATURES = [
  {
    slug: "cover",
    name: "화면 가리기",
    lead: "버튼 하나로 모든 화면이 앞을 봅니다.",
    body: "교사가 '화면 가리기'를 누르면 학생 화면이 '선생님을 보세요'로 덮이고 그리기가 멈춥니다. 다시 누르면 바로 이어서 그립니다.",
    alt: "왼쪽은 화면 보여주기 버튼이 켜진 교사 화면, 오른쪽은 '선생님을 보세요' 가림막이 덮인 학생 화면",
  },
  {
    slug: "together",
    name: "함께 그리기",
    lead: "다 같이 그리고, 서로 보며 배웁니다.",
    body: "반 전체가 한 캔버스에 동시에 그리고, 친구 커서가 실시간으로 오갑니다. 화면을 조금 옮기면 옆 모둠과 친구가 어떻게 풀었는지 보고 참고할 수 있습니다.",
    alt: "여러 모둠 칸이 동시에 채워지고 학생 이름표가 달린 커서가 오가는 교사 화면",
  },
  {
    slug: "focus",
    name: "내 칸 지키기",
    lead: "내 칸은 내가, 친구 칸은 지켜집니다.",
    body: "집중모드에서는 자기 프레임에만 그릴 수 있습니다. 친구 것을 건드리면 제자리로 돌아가고 '친구 것은 고칠 수 없어요'가 뜹니다. 서로 도와야 할 때는 도움모드로 바꿉니다.",
    alt: "집중모드의 학생 화면에 '친구 것은 고칠 수 없어요' 안내가 뜬 모습",
  },
  {
    slug: "seal",
    name: "마감과 댓글",
    lead: "다 했으면 마감, 그다음은 댓글.",
    body: "마감한 프레임은 마감을 풀기 전까지 학생이 고칠 수 없습니다. 댓글은 마감된 작품에만 열려서, 그리는 도중이 아니라 완성한 뒤에 피드백을 주고받습니다.",
    alt: "마감 배지가 붙은 학생 작품과 교사 댓글이 달린 댓글 창",
  },
  {
    slug: "presentation",
    name: "발표 수업",
    lead: "학생마다 자기 슬라이드, 발표는 TV로.",
    body: "「발표 수업」으로 캔버스를 만들면 학생마다 자기 슬라이드가 생깁니다. 학생이 「완료」를 누르면 교사 화면의 학생 카드에 바로 보이고, 교사 컴퓨터를 TV에 연결해 전체 화면 슬라이드쇼로 반 전체가 함께 봅니다.",
    alt: "교사의 발표 수업 화면. 번호순 학생 카드에 완료·작성 중 상태와 슬라이드 수, 열기·발표 버튼이 있고 위에 완료 인원이 보이는 모습",
  },
  {
    slug: "pulse",
    name: "참여 현황·손들기",
    lead: "누가 들어왔는지, 누가 손들었는지.",
    body: "참여 현황에서 지금 캔버스에 들어와 있는 학생을 번호순으로 확인하고, 학생이 누른 손들기는 교사 화면에만 줄을 섭니다. 한 명씩 돌아다니며 묻지 않아도 됩니다.",
    alt: "교사 화면의 참여 현황 목록과 손든 학생 줄",
  },
  {
    slug: "accounts",
    name: "학생 계정 준비",
    lead: "학생 이메일 없이, 학급 하나로 최대 30명 준비.",
    body: "학급 이름과 계정 접두어만 정하면 학생 계정이 최대 30개까지 한 번에 만들어집니다. 「학생별 안내문 인쇄」로 아이마다 한 장씩 나눠 주면 끝입니다. 명단과 CSV는 선생님 보관용입니다.",
    alt: "학급 학생 탭에 번호별 아이디가 늘어서 있고 학생별 안내문 인쇄, 명단 인쇄, CSV 내려받기 버튼이 있는 교사 화면",
  },
] as const;

export const STEPS = [
  {
    title: "먼저 학급을 만듭니다.",
    body: "학급 이름과 계정 접두어만 정하면 학생 계정이 최대 30개까지 준비됩니다.",
  },
  {
    title: "그다음 계정을 나눠 줍니다.",
    body: "학생별 안내문을 인쇄해 아이마다 한 장씩 나눠 줍니다. 반 전체 명단은 선생님 보관용입니다.",
  },
  {
    title: "캔버스를 열면 수업 시작.",
    body: "오늘 그릴 캔버스를 만들면, 아이들은 자기 번호로 로그인해 같은 캔버스에 그립니다.",
  },
] as const;

/** 랜딩 마지막 안내(시작하기)에 붙는 한 줄. */
export const FREE_NOTE = "교사·학생 모두 무료입니다.";

export const FAQS = [
  {
    q: "크루버스와 크루바스는 같은 서비스인가요?",
    a: "네, 같은 서비스입니다. 한글 이름을 크루버스에서 크루바스로 바꿨습니다. 영문 이름 Crewvas와 주소 crewvas.com은 그대로이고, 로그인·학급·학생 계정·작품도 그대로 씁니다.",
  },
  {
    q: "학생도 이메일이 필요한가요?",
    a: "아니요. 학급을 만들면 학생 계정이 최대 30개까지 준비됩니다. 아이들은 안내받은 아이디와 비밀번호로 로그인합니다.",
  },
  {
    q: "몇 명이 같이 그릴 수 있나요?",
    a: "교사 1명과 학생 약 20명이 같은 캔버스를 동시에 편집하는 환경을 기준으로 만들었습니다. 학급당 학생 계정은 최대 30개입니다.",
  },
  {
    q: "학생이 다른 모둠 자리를 건드리면요?",
    a: "집중모드에서는 자기 프레임에만 그릴 수 있습니다. 함께 고쳐야 할 때는 도움모드로 바꾸면 친구 프레임도 열립니다.",
  },
  {
    q: "학생 발표 자료도 만들 수 있나요?",
    a: "네. 선생님이 캔버스를 만들 때 템플릿에서 「발표 수업」을 고르면 학생마다 자기 발표 캔버스가 생깁니다. 학생 캔버스는 그 학생과 선생님만 열 수 있고, 슬라이드는 한 사람당 30장까지입니다. 다 만들면 선생님 화면의 학생 카드에서 완료를 확인하고, 전체 화면 슬라이드쇼로 발표합니다.",
  },
  {
    q: "함께 그린 내용은 어떻게 되나요?",
    a: "캔버스는 저장되고, 교사는 캔버스 이력을 확인해 이전 상태로 복원할 수 있습니다.",
  },
  {
    q: "캔버스를 잘못 지웠을 때는요?",
    a: "휴지통으로 옮긴 캔버스는 30일 안에 복원할 수 있습니다. 옮기는 즉시 학생 목록에서는 사라집니다.",
  },
  {
    q: "학년이 끝난 학급은요?",
    a: "학급을 보관하면 학생 로그인과 편집이 중지됩니다. 교사는 읽기와 내보내기를 계속할 수 있고, 다시 사용할 수도 있습니다.",
  },
  {
    q: "비용이 드나요?",
    a: "아니요. 교사와 학생 모두 무료로 씁니다. 교사는 구글 계정으로 로그인하면 바로 시작할 수 있습니다.",
  },
  {
    q: "누가 만들었나요?",
    a: "직접 만든 사람은 현직 초등 교사입니다. 자기 반 수업에 쓰려고 만들었고, 지금도 그 학급의 실제 수업에서 쓰고 있습니다.",
  },
  {
    q: "어떤 기기에서 쓰나요?",
    a: "설치 없이 웹 브라우저로 씁니다. 그리기는 태블릿이나 노트북·PC에서 할 수 있고, 휴대폰에서는 보기만 할 수 있습니다. 한 캔버스는 교사 1명과 학생 약 20명이 함께 그리는 기준입니다.",
  },
] as const;
